/* unplugin-vue-components disabled */import { render } from "./html-mapper.vue?vue&type=template&id=6843b10c"
import script from "./html-mapper.vue?vue&type=script&lang=js"
export * from "./html-mapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/md-content-v2/html-mapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6843b10c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6843b10c', __exports__)) {
    api.reload('6843b10c', __exports__)
  }
  
  module.hot.accept("./html-mapper.vue?vue&type=template&id=6843b10c", () => {
    api.rerender('6843b10c', render)
  })

}


export default __exports__